import React from "react";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";

export type RowSource = "question" | "metric";

interface RowSourceToggleProps {
  value: RowSource;
  onChange: (source: RowSource) => void;
  isDisabled?: boolean;
}

/** Question/Metric row-source choice inside the shared Add Row / Edit Row
 *  builder shell — defaults to Question. Disabled while editing an existing
 *  row: switching a configured row's source is deferred past this pass. */
const RowSourceToggle: React.FC<RowSourceToggleProps> = ({ value, onChange, isDisabled }) => (
  <Box sx={{ mb: 1.5 }}>
    <RadioGroup
      row
      value={value}
      onChange={(e) => onChange(e.target.value as RowSource)}
    >
      <FormControlLabel
        value="question"
        control={<Radio size="small" />}
        label="Question"
        disabled={isDisabled}
      />
      <FormControlLabel
        value="metric"
        control={<Radio size="small" />}
        label="Metric"
        disabled={isDisabled}
      />
    </RadioGroup>
  </Box>
);

export default RowSourceToggle;
